<template>
  <div :id="id" class="h-full w-full" @dblclick="wholeFullScreen"></div>
</template>

<script>
import { BaseApi } from '@wiz-api/hik-isecure-center'

const baseApi = new BaseApi()

export default {
  props: {
    id: {
      type: String,
      default: 'hk-player',
    },
    cameraIndexCode: {
      type: String,
    },
  },
  data() {
    return {
      oPlugin: null, // 播放器实例
      curIndex: 0, // 当前选中窗口下标
      iWind: 0, //
      videoUrl: '', // 视频流
      showVideo: false, // resize前需要判断是否实例化完成播放器
    }
  },
  watch: {
    cameraIndexCode(val) {
      if (val) {
        if ('WebSocket' in window && this.videoUrl) {
          // 关闭上一个websocket连接
          const ws = new WebSocket(this.videoUrl)
          ws.close()
        }
        if (this.oPlugin) {
          this.stopPlay()
        }
        this.$nextTick(() => {
          this.initCamera()
        })
      }
    },
  },
  computed: {
    // 获取海康监控协议
    HKH5playerProtocol() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management"].config.HKH5playerProtocol'
      ) || 'ws'
    },
  },
  created() {},
  mounted() {
    this.initCamera()
  },
  beforeDestroy() {
    this.stopPlay()
  },
  methods: {
    // 播放器简单配置
    initCamera() {
      this.oPlugin = new JSPlugin({
        szId: this.id, // 容器id 需要英文字母开头
        szBasePath: '/lib/video/HKh5Player/', // 资源文件
        iMaxSplit: 1, // 分屏播放，当前为1
        oStyle: {
          // 设置播放器样式
          border: '#343434',
          borderSelect: '#000',
          background: '#000',
        },
        openDebug: true,
      })
      this.initPlugin()
    },
    // 事件初始化
    initPlugin() {
      this.oPlugin.JS_SetWindowControlCallback({
        windowEventSelect(iWndIndex) {
          // 插件选中窗口回调
          this.iWind = iWndIndex
        },
        pluginErrorHandler(iWndIndex, iErrorCode, oError) {
          // 插件错误回调
          console.error(`插件错误回调   window-${iWndIndex}, errorCode: ${iErrorCode}`, oError)
        },
        windowEventOver(iWndIndex) {
          // 鼠标移过回调
          console.log('鼠标移过回调')
        },
        windowEventOut(iWndIndex) {
          // 鼠标移出回调
          console.log('鼠标移出回调')
        },
        windowEventUp(iWndIndex) {
          // 鼠标mouseup事件回调
          console.log('鼠标mouseup事件回调')
        },
        windowFullCcreenChange(bFull) {
          // 全屏切换回调
          console.log('全屏切换回调')
        },
        firstFrameDisplay(iWndIndex, iWidth, iHeight) {
          // 首帧显示回调
          console.log(iWndIndex, iWidth, iHeight)
        },
        performanceLack() {
          // 性能不足回调
          console.log('性能不足回调')
        },
      })
      this.oPlugin
        .JS_SetOptions({
          // bSupportSound: false  //是否支持音频，默认支持
          // bSupporDoubleClickFull: false  //是否双击窗口全屏，默认支持
          // bOnlySupportMSE: true  //只支持MSE
          // bOnlySupportJSDecoder: true  //只支持JSDecoder
        })
        .then(async () => {
          // 播放器实例化完成
          this.showVideo = true
          this.getWS()
        })
    },
    // 获取视频流
    async getWS() {
      const params = {
        cameraIndexCode: this.cameraIndexCode,
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: this.HKH5playerProtocol || 'ws', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        expand: 'transcode=0',
        streamform: 'ps',
      }
      const params2 = {
        url: '/artemis/api/video/v2/cameras/previewURLs',
        input: JSON.stringify(params),
      }
      const [err, res] = await baseApi.postHIK_0(params2)
      if (!err && res) {
        console.log('获取视频流', res)
        this.videoUrl = JSON.parse(res).data.url
        this.realplay()
      }
    },
    // 播放视频
    realplay() {
      this.oPlugin
        .JS_Play(
          this.videoUrl,
          {
            playURL: this.videoUrl,
            mode: 1, // 0：普通模式   1：高级模式
          },
          this.curIndex
        )
        .then(() => {
          console.log('realplay success')
        })
        .catch(() => {
          console.log('realplay failed')
        })
    },
    // 停止播放
    stopPlay() {
      this.oPlugin
        .JS_Stop(this.curIndex)
        .then(() => {
          console.log('JS_Stop success')
        })
        .catch(() => {
          console.log('JS_Stop failed')
        })
    },
    // 整体全屏
    wholeFullScreen() {
      this.oPlugin.JS_FullScreenDisplay(true).then(
        () => { console.log('wholeFullScreen success') },
        (e) => { console.error(e) }
      )
    },
    // 设置窗口大小
    resizeVideo() {
      if (this.showVideo) {
        this.oPlugin
          .JS_Resize()
          .then(() => {
            console.log('resizeplay success')
          })
          .catch(() => {
            console.log('resizeplay failed')
          })
      }
    },
    fullScreen() {
      this.oPlugin
        .JS_FullScreenSingle(this.curIndex)
        .then(() => {
          console.log('JS_FullScreenDisplay success')
        })
        .catch((e) => {
          console.log(e, 'JS_FullScreenDisplay faild')
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
